import React from 'react';
//import logo from './assets/visioN.svg';
import '../App.less';
import { 
    Button,
    Typography, 
    Divider,
    Row, 
    Col,
    Card,
    Image,
    Space,
    Avatar,
    Tabs
  } from 'antd';

import { Link } from "react-router-dom";

const { 
  Text, 
  Title
} = Typography;

const gridStyle = {
  width: '50%',
  textAlign: 'center',
};

function DesignTech() {
    return (
      <div>
                <Row>
                <Link to="/content/Sensable">
                      <div className="divImage">
                        <Image height={300} src={require("../assets/projects/sensable/sensable_1.png")}/>
                      </div>
                      <div className="m16-t m24-b">
                          <Title level={3}>Sensable</Title>
                          <Text className="imgDesc">Smart jewelry enabling humans to explore and sense biotic and abiotic elements in the neighborhood</Text>
                      </div>
                    </Link>
                </Row>

                <Row className="p16-t" justify="space-between">
                  <Col xs={24} sm={24} md={24} lg={12} xl={12}>
                    <Link to="/content/footUI">
                      <div className="divImage">
                        <Image height={300} src={require("../assets/home/1_thumbnail.png")}/>
                      </div>
                      <div className="m16-t m24-b">
                          <Title level={3}>foot UI - Tactical Urbanism</Title>
                          <Text className="imgDesc">Set of explorations on how to create casual interactions between people in public spaces in a way that encourages distancing and safety</Text>
                      </div>
                    </Link>
                  </Col>
                  <Col xs={24} sm={24} md={24} lg={11} xl={11}>
                    <Link to="/content/Chromoskyn">
                      <div className="divImage">
                        <Image height={300} src={require("../assets/home/2_thumbnail.png")}/>
                      </div>
                      <div className="m16-t m24-b">
                          <Title level={3}>Chromoskyn</Title>
                          <Text className="imgDesc">Living organic tattoos that represent air quality in your city</Text>
                      </div>
                    </Link>
                  </Col>
                </Row>

                <Row className="p16-t" justify="space-between">
                  <Col xs={24} sm={24} md={24} lg={12} xl={12}>
                    <Link to="/content/Flow">
                      <div className="divImage">
                        <Image height={300} src={require("../assets/home/3_thumbnail.png")}/>
                      </div>
                      <div className="m16-t m24-b">
                          <Title level={3}>Flow</Title>
                          <Text className="imgDesc">Flow is a Behavioral design project focussing on water consciousness</Text>
                        </div>
                    </Link>
                  </Col>
                  <Col xs={24} sm={24} md={24} lg={11} xl={11}>
                    <Link to="/content/Pinaza">
                      <div className="divImage">
                        <Image height={300} src={require("../assets/home/4_thumbnail.png")}/>
                      </div>
                      <div className="m16-t m24-b">
                          <Title level={3}>Pinaza</Title>
                          <Text className="imgDesc">a speculative design project imagining an underwater future in 2147 where scarce energy is being rationed within the community with a focus on exploring meaningful connections</Text>
                        </div>
                    </Link>
                  </Col>
                </Row>

                <Row className="p16-t" justify="space-between">
                  <Col xs={24} sm={24} md={24} lg={12} xl={12}>
                    <Link to="/content/NewTen">
                      <div className="divImage">
                        <Image height={300} src={require("../assets/home/5_thumbnail.png")}/>
                      </div>
                      <div className="m16-t m24-b">
                          <Title level={3}>NewTen</Title>
                          <Text className="imgDesc">an interactive artifact that alters the way you consume news by giving users control over the news they consume</Text>
                        </div>
                    </Link>
                  </Col>
                  <Col xs={24} sm={24} md={24} lg={11} xl={11}>
                    <Link to="/content/Sc8r">
                      <div className="divImage">
                        <Image height={300} src={require("../assets/home/6_thumbnail.png")}/>
                      </div>
                      <div className="m16-t m24-b">
                          <Title level={3}>sc8r</Title>
                          <Text className="imgDesc">Community driven nudge to encourage skateboarders to explore and grow</Text>
                        </div>
                    </Link>
                  </Col>
                </Row>

                <Row className="m120-t">
                  <Text><strong>Other Projects - external links</strong></Text>
                </Row>


                <Row className="p16-t" justify="space-between">
                  <Col xs={24} sm={24} md={24} lg={8} xl={8}>
                    <a href="http://ciid.dk/education/portfolio/idp20/courses/connected-objects-tui/projects/siderum/" target="_blank" rel="noopener noreferrer">
                      <div className="divImage">
                        <Image height={300} src={require("../assets/home/7_thumbnail.png")}/>
                      </div>
                      <div className="m16-t m24-b">
                          <Title level={3}>siderum</Title>
                          <Text className="imgDesc">is a speculative design project imagining interplanetary time keeping with the aim to explore people-to-sense of time connection</Text>
                        </div>
                    </a>
                  </Col>
                  <Col xs={24} sm={24} md={24} lg={7} xl={7}>
                    <a href="http://ciid.dk/education/portfolio/idp20/courses/connected-objects-tui/projects/toucanna-break/" target="_blank" rel="noopener noreferrer">
                      <div className="divImage">
                        <Image height={300} src={require("../assets/home/8_thumbnail.png")}/>
                      </div>
                      <div className="m16-t m24-b">
                          <Title level={3}>Toucana break</Title>
                          <Text className="imgDesc">is a pair of networked devices that encourage people to take breaks from work</Text>
                        </div>
                    </a>
                  </Col>
                  <Col xs={24} sm={24} md={24} lg={7} xl={7}>
                    <a href="http://ciid.dk/education/portfolio/idp20/courses/intro-to-programming/projects/kosmoz/" target="_blank" rel="noopener noreferrer">
                      <div className="divImage">
                        <Image height={300} src={require("../assets/home/9_thumbnail.png")}/>
                      </div>
                      <div className="m16-t m24-b">
                          <Title level={3}>KOSMOZ</Title>
                          <Text className="imgDesc">a physically active online game that lets you choose from a list  of your body movements as tool to play with</Text>
                        </div>
                    </a>
                  </Col>
                </Row>

                <Row className="p16-t" justify="space-between">
                  <Col xs={24} sm={24} md={24} lg={8} xl={8}>
                    <a href="http://ciid.dk/education/portfolio/idp20/courses/machine-learning/projects/tictrak/" target="_blank" rel="noopener noreferrer">
                      <div className="divImage">
                        <Image height={300} src={require("../assets/home/10_thumbnail.png")}/>
                      </div>
                      <div className="m16-t m24-b">
                          <Title level={3}>tiktrak</Title>
                          <Text className="imgDesc">a customizable real-time tracking system for tics and habits</Text>
                        </div>
                    </a>
                  </Col>
                  <Col xs={24} sm={24} md={24} lg={7} xl={7}>
                    <a href="http://ciid.dk/education/portfolio/idp20/courses/service-design/projects/intercambio/" target="_blank" rel="noopener noreferrer">
                      <div className="divImage">
                        <Image height={300} src={require("../assets/home/11_thumbnail.png")}/>
                      </div>
                      <div className="m16-t m24-b">
                          <Title level={3}>Intercambio</Title>
                          <Text className="imgDesc">is a service to connect skilled professionals willing to work remotely in a foreign country with local businesses that aim to make a difference</Text>
                        </div>
                    </a>
                  </Col>
                  <Col xs={24} sm={24} md={24} lg={7} xl={7}>
                    <a href="http://ciid.dk/education/portfolio/idp20/courses/beyond-the-pocket-computer/projects/lovester/" target="_blank" rel="noopener noreferrer">
                      <div className="divImage">
                        <Image height={300} src={require("../assets/home/12_thumbnail.png")}/>
                      </div>
                      <div className="m16-t m24-b">
                          <Title level={3}>Lovester</Title>
                          <Text className="imgDesc">is a playful take on wearable device technology leveraging serendipitous moments in the physical world to create an opportunity for meeting new people with confidence</Text>
                        </div>
                    </a>
                  </Col>
                </Row>

                <Row className="p16-t" justify="space-between">
                  <Col xs={24} sm={24} md={24} lg={8} xl={8}>
                    <a href="http://ciid.dk/education/portfolio/idp20/courses/prototyping-as-a-process/projects/align/" target="_blank" rel="noopener noreferrer">
                      <div className="divImage">
                        <Image height={300} src={require("../assets/home/13_thumbnail.png")}/>
                      </div>
                      <div className="m16-t m24-b">
                          <Title level={3}>Align</Title>
                          <Text className="imgDesc">is a gentle companion for older adults to aid in daily task completion</Text>
                        </div>
                    </a>
                  </Col>
                  <Col xs={24} sm={24} md={24} lg={7} xl={7}>
                    <a href="http://ciid.dk/education/portfolio/idp20/courses/introduction-to-ixd/projects/starling/" target="_blank" rel="noopener noreferrer">
                      <div className="divImage">
                        <Image height={300} src={require("../assets/home/14_thumbnail.png")}/>
                      </div>
                      <div className="m16-t m24-b">
                          <Title level={3}>Starling</Title>
                          <Text className="imgDesc">is an interactive subway installation to make people more cognizant of ourselves in relation to the world around us.</Text>
                        </div>
                    </a>
                  </Col>
                  <Col xs={24} sm={24} md={24} lg={7} xl={7}>
                    <a href="http://ciid.dk/education/portfolio/idp20/courses/spatial-computing/projects/ar-trip/" target="_blank" rel="noopener noreferrer">
                      <div className="divImage">
                        <Image height={300} src={require("../assets/home/15_thumbnail.png")}/>
                      </div>
                      <div className="m16-t m24-b">
                          <Title level={3}>AR Trip</Title>
                          <Text className="imgDesc">was a week-long spacial computing exploration of augmented reality and its applications</Text>
                        </div>
                    </a>
                  </Col>
                </Row>
      </div>
    );
  }
  
export default DesignTech;



                  